import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { IHeadboard2Props } from '../headboard2';
import { customTitle } from '../../../../utils/customTitle';

function headboard2Adapter(data: any): IHeadboard2Props {
    return {
        title: data.tituloPrincipal ? customTitle(data.tituloPrincipal) : '',
        subtitle: data.tituloSpan ?? data.tituloSpan,
        image: data.imagenHeader.file.url ?? data.imagenHeader.file.url,
        description:
            data.descripcion ?
            documentToReactComponents(JSON.parse(data.descripcion.raw)) : '',
        btnLabel: data.tituloBoton ?? data.tituloBoton,
        redirection: data.redireccionBoton ?? data.redireccionBoton,
        breadcrumb: data.migaDePan ? data.migaDePan : '',
    };
}

export default headboard2Adapter;
